/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Injectable, inject } from '@angular/core'
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router'
import { paths } from '../pages/pages.paths'
import { ConfigService } from '../services/configuration/config.service'
import { FeatureToggle } from '../services/feature-toggles.defintions'
import { FeatureToggleService } from '../services/feature-toggle/feature-toggle.service'

@Injectable({
  providedIn: 'root',
})
export class FeatureToggleGuard {
  private featureToggleService = inject(FeatureToggleService)
  private configService = inject(ConfigService)
  private router = inject(Router)

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (
      route.data.featureToggle.every(
        (featureToggle: string) =>
          this.featureToggleService.isFeatureEnabled(featureToggle, false, true) &&
          (this.featureToggleService.isFeatureEnabled(FeatureToggle.HIDE_PAYMENT_AND_ORDER_SLICE, true, false) === false ||
            this.featureToggleService.isFeatureEnabled(FeatureToggle.HIDE_SECONDARY_USER_SLICE, true, false) === false),
      )
    ) {
      const country = this.configService.getUrlCountry()
      const locale = this.configService.getUrlLocale()

      return this.router.parseUrl(`${country}/${locale}/${paths.personalData}`)
    }
    return true
  }
}
